
   $(document).ready(function() {
     
      $("#second-slide-screen").show();
     $(".buy-now-body").click(function (e) {
           e.stopPropagation();
           $("#first-slide-screen").hide();
           $("#second-slide-screen").show();
       });
      $(".prev").click(function (e) {
           e.stopPropagation();
        $("#second-slide-screen").show();
            $("#slider-wrapper-rr").show();
        $("#slider-wrapper-both").hide();
      
        $("#slider-wrapper-J1772").hide();
          $("#slider-wrapper-second").hide();
       });
       $(".next").click(function (e) {
           e.stopPropagation();
        $("#second-slide-screen").show();
          $("#slider-wrapper-second").hide();
             $("#slider-wrapper-third").show();
       });
      $(".next-J1772").click(function (e) {
           e.stopPropagation();
        $("#second-slide-screen").show();
          $("#slider-wrapper-second").hide();
         $("#slider-wrapper-J1772").hide();
            $("#slider-wrapper-adapter-J1772").show();
        
       });
     
      $(".prev_1").click(function (e) {
           e.stopPropagation();
          $("#second-slide-screen").show();
          $("#slider-wrapper-third").hide();
          $("#slider-wrapper-second").show();
       });
        $(".prev_2").click(function (e) {
           e.stopPropagation();
        $("#second-slide-screen").show();
            $("#slider-wrapper-fourth").hide();
             $("#slider-wrapper-charger-tesla").hide();
          $("#slider-wrapper-second").show();
       });
       $(".prev_2_J1772").click(function (e) {
           e.stopPropagation();
        $("#second-slide-screen").show();
            $("#slider-wrapper-fourth").hide();
          $("#slider-wrapper-J1772").show();
         $("#slider-wrapper-adapter-J1772").hide();
         $("#slider-wrapper-charger-J1772").hide();
         $("#slider-wrapper-charging-station").hide();
         $("#slider-wrapper-charger-tesla").hide();
       });
       $(".prev_2_both").click(function (e) {
           e.stopPropagation();
        $("#second-slide-screen").show();
        $("#slider-wrapper-fourth").hide();
        $("#slider-wrapper-both").show();
        $("#slider-wrapper-adapter-both").hide();
        $("#slider-wrapper-charger-both").hide();
        $("#slider-wrapper-both-charging-station").hide();
         $("#slider-wrapper-tesla-charging-station").hide();
         $("#slider-wrapper-charger-tesla").hide();
         
       });
     $(".prev_2_tesla").click(function (e) {
           e.stopPropagation();
         $("#second-slide-screen").show();
          $("#slider-wrapper-fourth").hide();
          $("#slider-wrapper-second").show();
         $("#slider-wrapper-adapter-both").hide();
         $("#slider-wrapper-charger-both").hide();
         $("#slider-wrapper-both-charging-station").hide();
         $("#slider-wrapper-tesla-charging-station").hide();
         $("#slider-wrapper-charger-tesla").hide();
     });
       $(".back-arrow").click(function (e) {
           e.stopPropagation();
           $("#second-slide-screen").show();
         
          $("#slider-wrapper-rr").show();
          $("#slider-wrapper-third").hide();
       });
       $(".back-arrow_1").click(function (e) {
           e.stopPropagation();
           $("#second-slide-screen").show();
         
           $("#slider-wrapper-J1772").hide();
              $("#slider-wrapper-both").hide();
          $("#slider-wrapper-rr").show();
          $("#slider-wrapper-second").hide();
          
       });
       $(".back-arrow_2").click(function (e) {
           e.stopPropagation();
           $("#second-slide-screen").show();
         
          $("#slider-wrapper-rr").show();
          $("#slider-wrapper-fourth").hide();
          $("#slider-wrapper-adapter-J1772").hide();
          $("#slider-wrapper-adapter-both").hide();
          $("#slider-wrapper-charging-station").hide();
          $("#slider-wrapper-both-charging-station").hide();
          $("#slider-wrapper-tesla-charging-station").hide();
          $("#slider-wrapper-charger-tesla").hide();
          
         
         $("#slider-wrapper-charger-J1772").hide();
          $("#slider-wrapper-charger-both").hide();
          
       });
      $("#slider-wrapper-rr").show();
           $(".test1").click(function (e) {
               e.stopPropagation();
   
               $("#slider-wrapper-second").show();
               $("#slider-wrapper-rr").hide();
      
               $(".tesla-screen-btn").show();
               $(".fisrt-screen-btn").hide();   
   
     });
     $("#slider-wrapper-rr").show();
           $(".test2").click(function (e) {
               e.stopPropagation();
   
               $("#slider-wrapper-J1772").show();
               $("#slider-wrapper-rr").hide();
   
                $(".tesla-screen-btn").show();
               $(".fisrt-screen-btn").hide();
   
      });
      $("#slider-wrapper-rr").show();
           $(".test3").click(function (e) {
               e.stopPropagation();
   
               $("#slider-wrapper-both").show();
               $("#slider-wrapper-rr").hide();   
   
               $(".tesla-screen-btn").show();
               $(".fisrt-screen-btn").hide();   
   
           });
   
           $(".click-charger").click(function () {
               $("#slider-wrapper-third").show();
               $("#slider-wrapper-rr").hide();
               $("#slider-wrapper-second").hide();
   
               $(".tesla-second-screen-btn").show();
               $(".tesla-screen-btn").hide();
               $(".fisrt-screen-btn").hide();   
   
           })
       $(".click-adapter").click(function () {
               $("#slider-wrapper-fourth").show();
               $("#slider-wrapper-rr").hide();
               $("#slider-wrapper-second").hide();
   
               $(".tesla-second-screen-btn").show();
               $(".tesla-screen-btn").hide();
               $(".fisrt-screen-btn").hide();
   
      })
     $(".click-J1772-adapter").click(function () {
               $("#slider-wrapper-adapter-J1772").show();
               $("#slider-wrapper-rr").hide();
               $("#slider-wrapper-second").hide();
               $("#slider-wrapper-J1772").hide();
   
               $(".tesla-second-screen-btn").show();
               $(".tesla-screen-btn").hide();
               $(".fisrt-screen-btn").hide();
   
      })
      $(".click-both-adapter").click(function () {
               $("#slider-wrapper-adapter-both").show();
               $("#slider-wrapper-rr").hide();
               $("#slider-wrapper-second").hide();
               $("#slider-wrapper-both").hide();
   
               $(".tesla-second-screen-btn").show();
               $(".tesla-screen-btn").hide();
               $(".fisrt-screen-btn").hide();
   
           })
      $(".click-J1772-charger").click(function () {
               $("#slider-wrapper-charger-J1772").show();
               $("#slider-wrapper-rr").hide();
               $("#slider-wrapper-second").hide();
               $("#slider-wrapper-J1772").hide();
   
               $(".tesla-second-screen-btn").show();
               $(".tesla-screen-btn").hide();
               $(".fisrt-screen-btn").hide();
   
           })
     $(".click-both-charger").click(function () {
               $("#slider-wrapper-charger-both").show();
               $("#slider-wrapper-rr").hide();
               $("#slider-wrapper-second").hide();
                $("#slider-wrapper-both").hide();
   
               $(".tesla-second-screen-btn").show();
               $(".tesla-screen-btn").hide();
               $(".fisrt-screen-btn").hide();
   
           })
           $(".click-J1772-station").click(function () {
               $("#slider-wrapper-charging-station").show();
               $("#slider-wrapper-rr").hide();
               $("#slider-wrapper-second").hide();
                $("#slider-wrapper-J1772").hide();
   
               $(".tesla-second-screen-btn").show();
               $(".tesla-screen-btn").hide();
               $(".fisrt-screen-btn").hide();
   
           })
             $(".click-both-station").click(function () {
               $("#slider-wrapper-both-charging-station").show();
               $("#slider-wrapper-rr").hide();
               $("#slider-wrapper-second").hide();
               $("#slider-wrapper-both").hide();
   
               $(".tesla-second-screen-btn").show();
               $(".tesla-screen-btn").hide();
               $(".fisrt-screen-btn").hide();   
           })

     $(".click-tesla-station").click(function () {
               $("#slider-wrapper-tesla-charging-station").show();
               $("#slider-wrapper-rr").hide();
               $("#slider-wrapper-second").hide();
               $("#slider-wrapper-both").hide();
   
               $(".tesla-second-screen-btn").show();
               $(".tesla-screen-btn").hide();
               $(".fisrt-screen-btn").hide();
   
           })
      $(".click-tesla-charger").click(function () {
               $("#slider-wrapper-charger-tesla").show();
               $("#slider-wrapper-rr").hide();
               $("#slider-wrapper-second").hide();
                $("#slider-wrapper-both").hide();
   
               $(".tesla-second-screen-btn").show();
               $(".tesla-screen-btn").hide();
               $(".fisrt-screen-btn").hide();
   
           })
   
           $('.sp').first().addClass('active');
           $('.sp').hide();
           $('.active').show();
   
           $('#button-next').click(function (event) {
               event.preventDefault();
               $('.active').removeClass('active').addClass('oldActive');
               if ($('.oldActive').is(':last-child')) {
                   $('.sp').first().addClass('active');
               }
               else {
                   $('.oldActive').next().addClass('active');
               }
               $('.oldActive').removeClass('oldActive');
               $('.sp').fadeOut();
               $('.active').fadeIn();
   
   
           });
   
           $('#button-previous').click(function (event) {
   
               event.preventDefault();
   
               $('.active').removeClass('active').addClass('oldActive');
               if ($('.oldActive').is(':first-child')) {
                   $('.sp').last().addClass('active');
               }
               else {
                   $('.oldActive').prev().addClass('active');
               }
               $('.oldActive').removeClass('oldActive');
               $('.sp').fadeOut();
               $('.active').fadeIn();
           });
   
           $('.sp-second').first().addClass('active1');
           $('.sp-second').hide();
           $('.active1').show();
   
           $('#button-next2').click(function () {
   
               $('.active1').removeClass('active1').addClass('oldActive1');
               if ($('.oldActive1').is(':last-child')) {
                   $('.sp-second').first().addClass('active1');
               }
               else {
                   $('.oldActive1').next().addClass('active1');
               }
               $('.oldActive1').removeClass('oldActive1');
               $('.sp-second').fadeOut();
               $('.active1').fadeIn();
   
   
           });
   
           $('#button-previous2').click(function () {
               $('.active1').removeClass('active1').addClass('oldActive1');
               if ($('.oldActive1').is(':first-child')) {
                   $('.sp-second').last().addClass('active1');
               }
               else {
                   $('.oldActive1').prev().addClass('active1');
               }
               $('.oldActive1').removeClass('oldActive1');
               $('.sp-second').fadeOut();
               $('.active1').fadeIn();
           });
   
   
           $('.sp-third').first().addClass('active2');
           $('.sp-third').hide();
           $('.active2').show();
   
           $('#button-next3').click(function () {
   
               $('.active2').removeClass('active2').addClass('oldActive2');
               if ($('.oldActive2').is(':last-child')) {
                   $('.sp-third').first().addClass('active2');
               }
               else {
                   $('.oldActive2').next().addClass('active2');
               }
               $('.oldActive2').removeClass('oldActive2');
               $('.sp-third').fadeOut();
               $('.active2').fadeIn();
   
   
           });
           $('#button-previous3').click(function () {
               $('.active2').removeClass('active2').addClass('oldActive2');
               if ($('.oldActive2').is(':first-child')) {
                   $('.sp-third').last().addClass('active2');
               }
               else {
                   $('.oldActive2').prev().addClass('active2');
               }
               $('.oldActive2').removeClass('oldActive2');
               $('.sp-third').fadeOut();
               $('.active2').fadeIn();
           });
   
   
   
           $('.sp-forth').first().addClass('active3');
           $('.sp-forth').hide();
           $('.active3').show();
   
           $('#button-next4').click(function () {
               $('.active3').removeClass('active3').addClass('oldActive3');
               if ($('.oldActive3').is(':last-child')) {
                   $('.sp-forth').first().addClass('active3');
               }
               else {
                   $('.oldActive3').next().addClass('active3');
               }
               $('.oldActive3').removeClass('oldActive3');
               $('.sp-forth').fadeOut();
               $('.active3').fadeIn();
   
   
           });
   
           $('#button-previous4').click(function () {
               $('.active3').removeClass('active3').addClass('oldActive3');
               if ($('.oldActive3').is(':first-child')) {
                   $('.sp-forth').last().addClass('active3');
               }
               else {
                   $('.oldActive3').prev().addClass('active3');
               }
               $('.oldActive3').removeClass('oldActive3');
               $('.sp-forth').fadeOut();
               $('.active3').fadeIn();
           });

     $("#accord_1").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 500                     
        }, 100); 
    });
     $("#accord_2").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 600                     
        }, 100); 
    });
     $("#accord_3").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 700                     
        }, 100); 
    });
     $("#accord_4").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 800                     
        }, 100); 
    });
     $("#accord_5").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 900                     
        }, 100); 
    });
   $("#accord_6").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 900                     
        }, 100); 
    });
     
  if (window.matchMedia('(max-width: 767px)').matches) {
    $("#accord_1").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 1000                     
        }, 100); 
    });
    $("#accord_2").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 1100                     
        }, 100); 
    });
  $("#accord_3").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 1200                     
        }, 100); 
    });
    $("#accord_4").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 1300                     
        }, 100); 
    });
    $("#accord_5").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 1400                     
        }, 100); 
    });
    $("#accord_6").click(function() 
    {
        $("body,html").animate(
        {
            scrollTop : 1500                     
        }, 100); 
    });
}
   $(".hoveimagecls").mouseover(function (e) {
    //$(".d-block").attr("src", "https://cdn.shopify.com/s/files/1/2948/6296/files/J1772_buyersguide02.png?v=1699953590");
      $(".d-block").attr("src", "https://cdn.shopify.com/s/files/1/2948/6296/files/buyersguide_j1772.png");
}).mouseout(function (e) {
   // $(".d-block").attr("src", "https://cdn.shopify.com/s/files/1/2948/6296/files/TESLA_buyersguide02.png?v=1699953942");
     $(".d-block").attr("src", "https://cdn.shopify.com/s/files/1/2948/6296/files/buyersguide_nacs.png");
     
   });
   $(".both-hover").mouseover(function (e) {
  //  $(".d-block").attr("src", "https://cdn.shopify.com/s/files/1/2948/6296/files/TESLAJ1772_buyersguide02.png?v=1699954420");
     $(".d-block").attr("src", "https://cdn.shopify.com/s/files/1/2948/6296/files/buyersguideboth.png");
     
}).mouseout(function (e) {
    //$(".d-block").attr("src", "https://cdn.shopify.com/s/files/1/2948/6296/files/TESLA_buyersguide02.png?v=1699953942");
     $(".d-block").attr("src", "https://cdn.shopify.com/s/files/1/2948/6296/files/buyersguide_nacs.png");
   });
    });
